import React, { useState, useEffect } from 'react'
import { Grid, TextField, Typography } from '@material-ui/core'

function PositionFilterModal({ value = [null, null], onChange }) {
  const [startValue, setStartValue] = useState(value[0] || '')
  const [endValue, setEndValue] = useState(value[1] || '')

  // Update local state when prop changes
  useEffect(() => {
    setStartValue(value[0] || '')
    setEndValue(value[1] || '')
  }, [value])

  const handleStartChange = (e) => {
    const newStartValue = e.target.value
    setStartValue(newStartValue)

    const start = newStartValue === '' ? null : Number(newStartValue)
    const end = endValue === '' ? null : Number(endValue)
    onChange([start, end])
  }

  const handleEndChange = (e) => {
    const newEndValue = e.target.value
    setEndValue(newEndValue)

    const start = startValue === '' ? null : Number(startValue)
    const end = newEndValue === '' ? null : Number(newEndValue)
    onChange([start, end])
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Position Filter
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Enter start and end positions to filter variants by genomic position.
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="Start Position"
          type="number"
          fullWidth
          value={startValue}
          onChange={handleStartChange}
          placeholder="Start"
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          label="End Position"
          type="number"
          fullWidth
          value={endValue}
          onChange={handleEndChange}
          placeholder="End"
        />
      </Grid>
    </Grid>
  )
}

export default PositionFilterModal
